import { useEffect } from "react";
import { TableCellAccountRedirect } from "../../../shared/Table/components/Cell";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import {
  loanStages,
  financingAssetTypes,
} from "../../../shared/dictionary/enums";

import RefreshButton from "../../../shared/ui/Refresh.Button";
import loanTermination from "../../../services/terminatedCollectionLoans/connector";
import TerminatedCandidates from "../../../components/terminationShared/TerminatedCandidates";

const TerminatedCollectionLoansComponent = (props) => {
  useEffect(() => {
    props.getTerminatedLoans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getColumnConfig = () => {
    return [
      {
        key: "AccountId",
        label: "Get ssn",
        filter: false,
        visible: true,
        type: CELL_TYPES.ssn,
      },
      { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
      {
        key: "CreditStage",
        label: "Loan stage",
        visible: true,
        enumDict: loanStages,
        type: CELL_TYPES.enum,
      },
      {
        key: "DueAndOverdue.Amount",
        label: "Amount Due",
        visible: true,
        type: CELL_TYPES.money,
      },
      {
        key: "Term",
        label: "Original Term",
        visible: true,
        type: CELL_TYPES.number,
      },
      {
        key: "NominalInterest.Value",
        label: "Interest",
        visible: true,
        type: CELL_TYPES.percentage,
      },
      { key: "OCR", label: "OCR", visible: true, type: CELL_TYPES.text },
      {
        key: "TotalPaid.Amount",
        label: "Paid amount",
        visible: true,
        type: CELL_TYPES.money,
      },
      /** old rows */
      {
        key: "AccountId",
        label: "Account Id",
        visible: false,
        type: CELL_TYPES.text,
        renderer: (value) => {
          return <TableCellAccountRedirect value={value} type={"accountId"} />;
        },
      },
      {
        key: "CreditType",
        label: "Asset Type",
        visible: false,
        enumDict: financingAssetTypes,
        type: CELL_TYPES.enum,
      },
      {
        key: "IssueDate",
        label: "Issue date",
        visible: true,
        type: CELL_TYPES.date,
      },
      {
        key: "TerminationStatusChange",
        label: "Termination Status Change",
        visible: true,
        type: CELL_TYPES.date,
      },
    ];
  };

  return (
    <div className="loans-layout body-height content-padding">
      <RefreshButton onRefreshClick={props.getTerminatedLoans} />
      <h3>Terminated Loans for collection:</h3>
      {!props.terminatedLoans.fetched ? (
        <div> Loading... </div>
      ) : (
        <div>
          <br />
          <TableNew
            {...props}
            columns={getColumnConfig()}
            items={props.terminatedLoans.data}
            actionColumnWidth={200}
            tableKey={"TerminatedLunarLoans-Main"}
          />
          <br />
          <TerminatedCandidates
            loadFiles={props.loadFiles}
            createFiles={props.createFiles}
            fileLoad={props.terminatedLoans.fileLoad}
            finalizeFile={props.finalizeFile}
            loadDetails={props.loadDetails}
            removeLoanFromFile={props.removeLoanFromFile}
          />
        </div>
      )}
    </div>
  );
};

export default loanTermination(TerminatedCollectionLoansComponent);
